import { render, staticRenderFns } from "./PlayQuiz.vue?vue&type=template&id=71b02742&scoped=true"
import script from "./PlayQuiz.vue?vue&type=script&lang=js"
export * from "./PlayQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b02742",
  null
  
)

export default component.exports